export default __webpack_public_path__ + "static/media/christmasLogoSingle.8d48dc7f.png";